import { render } from "./EditFile.vue?vue&type=template&id=6bb85372&scoped=true"
import script from "./EditFile.vue?vue&type=script&lang=js"
export * from "./EditFile.vue?vue&type=script&lang=js"

import "./EditFile.vue?vue&type=style&index=0&id=6bb85372&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb85372"]])

export default __exports__